<script>
import Title from '@/components/admin/common/TitleArea.vue'

const viewTitles = {
  delayed: '지연 화물 처리 목록',
  stalled: '상태 정체 화물 목록',
  received: '오더접수 목록',
  completed: '수령완료 목록',
  status: '현재 상태별 화물 목록',
}

export default {
  name: 'AdminDashboardOrderList',
  components: { Title },
  data() {
    return {
      loading: false,
      error: false,
      total: 0,
      rows: [],
      page: 1,
      pageSize: 50,
      description: { title: viewTitles[this.$route.query.view] || '대시보드 조회 목록' },
      columns: [
        { name: 'delayed_days', label: '접수 경과일', field: row => `${row.delayed_days || 0}일`, align: 'center' },
        { name: 'stalled_days', label: '정체일', field: row => `${row.stalled_days || 0}일`, align: 'center' },
        { name: 'statusName', label: '현재 상태', field: row => row.statusName || '-', align: 'center' },
        { name: 'hblNo', label: 'H/BL No.', field: 'hblNo', align: 'left' },
        { name: 'orderId', label: 'Order No.', field: 'orderId', align: 'left' },
        { name: 'partnerName', label: '파트너', field: row => row.partnerName || '-', align: 'left' },
        { name: 'acceptedAt', label: '오더접수 시각', field: 'acceptedAt', align: 'left' },
        { name: 'lastStatusChangedAt', label: '최근 상태 변경', field: 'lastStatusChangedAt', align: 'left' },
        { name: 'trackingState', label: '배송조회 상태', field: row => row.trackingState || '미조회', align: 'center' },
        { name: 'actions', label: '', field: 'actions', align: 'center' },
      ]
    }
  },
  computed: {
    maxPage() {
      return Math.max(Math.ceil(this.total / this.pageSize), 1)
    },
    criteria() {
      if (this.$route.query.view === 'delayed') return '오더접수 후 30일 이상이며 현재 수령완료가 아닌 화물'
      if (this.$route.query.view === 'stalled') return '최근 상태 변경 후 7일 이상이며 현재 수령완료가 아닌 화물'
      if (this.$route.query.view === 'status') return '오더접수 이력이 있고 현재 선택한 상태인 화물'
      if (this.$route.query.view === 'completed') return '선택 기간에 오더접수됐고 현재 수령완료인 화물'
      return '선택 기간에 오더접수 이력이 최초로 발생한 화물'
    }
  },
  methods: {
    async loadRows() {
      this.loading = true
      this.error = false
      try {
        const res = await this.$http({
          method: 'POST',
          url: '/api/dashboard/orders',
          data: {
            view: this.$route.query.view,
            period: this.$route.query.period,
            comparison: this.$route.query.comparison,
            date: this.$route.query.date,
            status: this.$route.query.status,
            partnerId: this.$route.query.partnerId,
            page: this.page,
            pageSize: this.pageSize,
          },
          name: '[ Axios / 대시보드 상세 목록 ]'
        })
        this.rows = res?.data?.items || []
        this.total = Number(res?.data?.total || 0)
      } catch (err) {
        this.$log.error('[ 대시보드 상세 목록 ]', err)
        this.rows = []
        this.total = 0
        this.error = true
      } finally {
        this.loading = false
      }
    },
    goToOrder(row) {
      if (!row?.hblNo) return
      this.$router.push({ name: 'Admin-parcel-infomation', query: { departure: 'dashboard', hblNo: row.hblNo } })
    },
    goBack() {
      this.$router.push('/admin/dashboard')
    }
  },
  mounted() {
    this.loadRows()
  }
}
</script>

<template>
  <q-page class="q-pa-lg">
    <div class="row q-mb-lg">
      <div class="col">
        <Title :desc="description">
          <q-btn flat round dense color="primary" icon="arrow_back" aria-label="대시보드로 돌아가기" @click="goBack">
            <q-tooltip>대시보드로 돌아가기</q-tooltip>
          </q-btn>
          <q-btn flat round dense color="primary" icon="refresh" aria-label="새로고침" @click="loadRows">
            <q-tooltip>새로고침</q-tooltip>
          </q-btn>
        </Title>
      </div>
    </div>

    <q-banner class="bg-blue-1 text-blue-10 q-mb-md" rounded>
      {{ criteria }} · {{ total }}건
    </q-banner>

    <q-banner v-if="error" class="bg-red-1 text-negative q-mb-md" rounded>
      목록을 불러오지 못했습니다. 새로고침 후 다시 시도해 주세요.
    </q-banner>

    <q-table
      flat
      bordered
      row-key="id"
      :rows="rows"
      :columns="columns"
      :loading="loading"
      :pagination="{ rowsPerPage: pageSize }"
      no-data-label="조회된 화물이 없습니다.">
      <template #body-cell-actions="props">
        <q-td :props="props">
          <q-btn flat dense color="primary" label="통합조회" @click="goToOrder(props.row)" />
        </q-td>
      </template>
    </q-table>
    <div v-if="maxPage > 1" class="row justify-center q-mt-md">
      <q-pagination v-model="page" :max="maxPage" color="primary" @update:model-value="loadRows" />
    </div>
  </q-page>
</template>
